import React from 'react';
import { clsx } from 'clsx';

interface AuthCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  name: string;
}

export const AuthCheckbox: React.FC<AuthCheckboxProps> = ({ 
  label, 
  error, 
  name, 
  className, 
  ...props 
}) => {
  return (
    <div className="space-y-1">
      <div className="flex items-start space-x-3">
        <input
          id={name}
          name={name}
          type="checkbox"
          className={clsx(
            "mt-0.5 h-4 w-4 rounded border-border bg-background text-primary accent-primary focus:ring-2 focus:ring-ring focus:ring-offset-0",
            error && "border-destructive",
            className
          )}
          {...props}
        />

        <label
          htmlFor={name}
          className="text-sm text-foreground leading-tight cursor-pointer"
        >
          {label}
        </label>
      </div>

      {error && (
        <p className="text-xs text-destructive mt-1">
          {error}
        </p>
      )}
    </div>
  );
};